import React from 'react';
import {
  required,
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextField,
  EditButton,
  ReferenceInput,
  AutocompleteInput,
  ReferenceField,
  Filter,
  TextInput,
  FunctionField,
} from 'react-admin';
import RejectPurchaseOrderBtn from '../skills/RejectPurchaseOrderBtn';
import ApprovePurchaseOrderBtn from './ApprovePurchaseOrderBtn';

const OrderFilter = (props) => (
  <Filter {...props}>
    <TextInput label="User Id" source="userId" />
    <TextInput label="PhoneNumber" source="phoneNumber" alwaysOn />
  </Filter>
);

const renderActionButtons = (status, id) => {
  const buttons = [];
  
  // Show approve button for requested orders
  if (status === 'REQUESTED') {
    buttons.push(<ApprovePurchaseOrderBtn key="approve" id={id} />);
  }
  
  // Show reject button for approved orders
  if (status === 'APPROVED') {
    buttons.push(<RejectPurchaseOrderBtn key="reject" id={id} />);
  }
  
  // No buttons for rejected orders (final state)
  
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {buttons}
    </div>
  );
}

export const PurchaseOrderListForLingoJourney = props => (
  <List title="Хөтөлбөрийн захиалгууд" {...props} filters={<OrderFilter/>}>
    <Datagrid optimized>
      <TextField label="ID" source="id" />
      <ReferenceField label="Хөтөлбөр" source="items.0.productId" reference="lingo/journeys">
        <TextField label="Нэр" source="title" />
      </ReferenceField>
      <ReferenceField source="userId" reference="users" label="Имэйл">
        <TextField source="email" />
      </ReferenceField>
      <TextField label="Төлбөр" source="items.0.amount" />
      <TextField label="Статус" source="status" />
      <FunctionField label="Actions" render={record => renderActionButtons(record.status, record.id)} />
      <EditButton />
    </Datagrid>
  </List>
);

export const PurchaseOrderCreateForLingoJourney = props => (
  <Create title="Хөтөлбөрийн захиалга үүсгэх" {...props}>
    <SimpleForm>
      <ReferenceInput label="Хэрэглэгч" source="userId" reference="users">
        <AutocompleteInput source="userId" optionText="email" validate={[required()]} />
      </ReferenceInput>
      <ReferenceInput
        label="Journey"
        source="journeyId"
        filterToQuery={q => ({ title: q })}
        reference="lingo/journeys"
      >
        <AutocompleteInput source="journeyId" optionText="title" validate={[required()]} />
      </ReferenceInput>
    </SimpleForm>
  </Create>
);
